import { Pipe, PipeTransform } from '@angular/core';

/**
 * @sample <div>{{ title | cut: 15 }}
 */
@Pipe({
  name: 'cutText',
})
export class CutTextPipe implements PipeTransform {
  transform(value: string, length: number): string {
    return value?.length > length ? value.substr(0, length) + ' ...' : value;
  }
}
